import createRemoteSettingHook from '@/utils/user/createRemoteSettingHook';

interface HomeLayoutExperimentSetting {
  enabled: boolean;
  itemsPerRow: number;
}

const REMOTE_SETTING_NAME = 'genai_studio_home_layout_ab';

const DEFAULT_SETTING: HomeLayoutExperimentSetting = {
  enabled: true,
  itemsPerRow: 6,
};

const isHomeLayoutExperimentSetting = (
  settings: unknown
): settings is HomeLayoutExperimentSetting =>
  typeof settings === 'object' &&
  settings !== null &&
  typeof (settings as HomeLayoutExperimentSetting).enabled === 'boolean' &&
  typeof (settings as HomeLayoutExperimentSetting).itemsPerRow === 'number';

const { useSetting } = createRemoteSettingHook({
  name: REMOTE_SETTING_NAME,
  defaultValue: DEFAULT_SETTING,
  validate: isHomeLayoutExperimentSetting,
  // Two values are needed, so this selects the whole setting rather than a
  // primitive. Still safe for the `Object.is` bail-out: both the module cache
  // and `DEFAULT_SETTING` are stable references, so an identity select returns
  // the same object every time rather than a fresh-but-equal one.
  select: (settings) => settings,
});

/**
 * Home layout A/B: which grid the card-row home renders and how many items fit
 * a row. Fetched once per session.
 */
const useHomeLayoutExperiment = (): {
  isCardRowLayout: boolean;
  itemsPerRow: number;
} => {
  const setting = useSetting();

  return {
    isCardRowLayout: setting.enabled,
    itemsPerRow: setting.itemsPerRow,
  };
};

export default useHomeLayoutExperiment;
